import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';

export const McdInvLedgerPymtDetail = () => {
  const tabSpecs = [{ id: 'info', label: 'Info', content: <EntityForm /> }];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
